import { AnimationEvent } from '@angular/animations';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output
} from '@angular/core';

import { SlideInOutDimension, slideInOut } from '@hdms/shared/util-core';

import { Accordion, AccordionState } from './accordion.types';

@Component({
  selector: 'shrd-uic-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  animations: [slideInOut('containerSlide', SlideInOutDimension.HEIGHT)],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccordionComponent implements Accordion {
  @HostBinding('class.shrd-uic-accordion') readonly hostClass = true;
  @HostBinding('class.is-closed') private closed = true;
  @HostBinding('class.is-opened') private opened = false;

  // TODO : temporary solution for move-dom directive inside filterbar
  // (we can't move content which is not rendered yet)
  @Input() keepContentVisible = false;

  @Output() accordionSlideDone = new EventEmitter<AccordionState>();

  public get isOpen(): boolean {
    return this.open;
  }

  private open: boolean = null;

  constructor(private readonly cdr: ChangeDetectorRef) {}

  toggleOpen(): void {
    this.open = !this.open;

    if (this.open) {
      this.closed = false;
    }

    this.opened = false;
    this.cdr.markForCheck();
  }

  close(): void {
    if (this.open) {
      this.toggleOpen();
    }
  }

  onContainerSlideDone(event: AnimationEvent): void {
    if (event.toState === null) {
      return;
    }
    if (!this.open) {
      this.closed = true;
      this.accordionSlideDone.emit(AccordionState.CLOSED);
    } else {
      this.opened = true;
      this.accordionSlideDone.emit(AccordionState.OPENED);
    }
    this.cdr.markForCheck();
  }
}
